import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-home\">\n  <path d=\"M10 0l10 10v10H0V10L10 0zM2 10.828V18h7v-7h5.001v7H18v-7.172l-8-8-8 8zM10 18h3v-6h-3v6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol